import React from 'react';
import { Animated as RNAnimated } from 'react-native';
import Animated from 'react-native-reanimated';
import Layout from './Layout';
const Row = React.forwardRef((props, ref) => (React.createElement(Layout, { direction: "row", ref: ref, ...props })));
export const AnimatedRow = Animated.createAnimatedComponent(Row);
export const RNAnimatedRow = RNAnimated.createAnimatedComponent(Row);
export default Row;
